import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useOperator } from "@/context/OperatorContext";
import { Loader2 } from "lucide-react";
import { brandPath } from "@/lib/brand";

export default function AfterAccess() {
  const { operator, redirectUrl } = useOperator();
  const navigate = useNavigate();
  const [msg, setMsg] = useState("Confirming your access…");

  useEffect(() => {
    if (operator === null) return;
    if (operator && operator.access) {
      if (operator.role === "superadmin") navigate(brandPath("/admin"));
      else if (operator.role === "tenant") navigate(brandPath("/dashboard"));
      else setMsg("Access confirmed, but no store is assigned to your account yet. Contact the platform owner.");
    } else {
      if (redirectUrl) { window.location.href = redirectUrl; return; }
      navigate(brandPath("/login"));
    }
  }, [operator, redirectUrl, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-background text-foreground">
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
      <p className="text-sm text-muted-foreground" data-testid="after-access-msg">{msg}</p>
    </div>
  );
}
